package com.mencanhealth.admin

import com.mencanhealth.admin.ui.AdminApp
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import org.jetbrains.compose.web.renderComposable

fun main() {
    Firebase.initialize(
        options = FirebaseOptions(
            apiKey = "AIzaSyAqkiiqWyu0Y8orUSc3b5JkHkGemyEIlAo",
            authDomain = "nutrimx-lemc.firebaseapp.com",
            projectId = "nutrimx-lemc",
            storageBucket = "nutrimx-lemc.firebasestorage.app",
            gcmSenderId = "721276905318",
            applicationId = "1:721276905318:web:f96c0ec032fc09973f0aa7"
        )
    )

    renderComposable(rootElementId = "root") {
        AdminApp()
    }
}
